import React, { useEffect, useState } from 'react';
import { ReactComponent as DialogIcon } from './assets/dialog-icon.svg';
import './ChatBotNotification.css';

type ChatBotNotificationProps = {
    toggleHandler: () => void;
    display: boolean;
}

function ChatBotNotification({ toggleHandler, display = true }: ChatBotNotificationProps) {
    const [currentDisplay, setCurrentDisplay] = useState(display);
    const [isVisible, setIsVisible] = useState(display); // New state to control visibility

    useEffect(() => {
        if (display) {
            setIsVisible(true); // Immediately make the component visible before starting fade-in
            setCurrentDisplay(true);
        } else {
            setCurrentDisplay(false);
            // Wait for the fade-out animation to complete before hiding the component
            const timer = setTimeout(() => {
                setIsVisible(false);
            }, 500); // Match this duration to your CSS transition duration
            return () => clearTimeout(timer);
        }
    }, [display]);

    return (
        <div
            className={`chatbot-toggle-container ${currentDisplay ? 'fade-in' : 'fade-out'}`}
            style={{
                // display: `${isVisible ? 'block' : 'none'}`,
                opacity: `${currentDisplay ? '1' : '0'}`,
                transition: 'opacity 0.5s ease-in-out',
                position: 'relative',
                zIndex: 900,
            }}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center',
            }}>
                <div style={{
                      fontSize: '16px',
                      color: '#333',
                      marginRight: '10px',
                      backgroundColor: '#fff',
                      padding: '10px 15px',
                      borderRadius: '5px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2), 0 6px 20px rgba(0,0,0,0.19)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid #ddd',
                      fontWeight: 500,
                }}>
                    免费在线咨询，请点击右边的图标!
                </div>
                <div onClick={() => {
                    toggleHandler();
                    console.log('ChatBotNotification clicked');
                }} className="pulse-animation icon-container"
                   style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#2F59C6',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.9)',
                }}>
                    <DialogIcon />
                </div>
            </div>
        </div>
    );
}

export default ChatBotNotification;
